import api from "./core";

const basePath = "api/core/TimeZones";

export default {
  query() {
    return api.post(`${basePath}`);
  }
};
